import { gql } from '@apollo/client';

const Fragments = {
  initializationParameterItem: gql`
    fragment initializationParameterItem on InitializationParameter {
      paramCode
      description
      valueType
      defaultValue
      categoryName
      editorType
      isInitializationParam
    }
  `
};

export default Fragments;
